import { useMemo } from "react";

import { get } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";

import act from "../store/actions";

const useAppDispatch = (path) => {
  const data = useSelector((state) => (path ? get(state, path) : state));
  const dispatch = useDispatch();
  const actions = useMemo(() => bindActionCreators(act, dispatch), [dispatch]);
  return {
    actions,
    data,
  };
};

export default useAppDispatch;
